import React from 'react';
import { AdvertPage } from './components/AdvertPage';
import { useNavigate } from 'react-router';

export default function AdvertPageWrapper() {
  const navigate = useNavigate();

  return (
    <AdvertPage
      onGetStarted={() => {
        // Navigate to main app
        navigate('/');
      }}
      onClose={() => {
        // Navigate back or to main app
        navigate('/');
      }}
    />
  );
}
